/* GENERATED FILE */
var schema = function(url, pipe, token) {
  var rel = function(path) {
    return (new URL(path, url)).href;
  };
  var qs = function(query) {
    const params = new URLSearchParams();
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        const value = query[key];
        params.append(key, value);
      }
    }
    return params.toString();
  };
  var opt = function(method, data) {
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    headers['ngrok-skip-browser-warning'] = '1';
    if (data === undefined) {
      return {
        method,
        headers: {
          ...headers,
        },
      };
    }
    if (data instanceof FormData) {
      return {
        method,
        headers: {
          ...headers,
        },
        body: data,
      };
    } else {
      return {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: JSON.stringify(data),
      };
    }
  };
  return {
    doc: {
      query: async function() {
        var url = rel(`/api/doc/`);
        let res = await fetch(url, opt("GET"));
        let body = null;
        try {
          body = (await res.json());
        } catch (err) {
          body = null;
        }
        res = {
          status: res.status,
          body,
        };
        if (pipe) {
          res = pipe(res);
        }
        return res;
      },
    },
    v1: {
      auth: {
        forgot: {
          post: async function(data) {
            var url = rel(`/api/v1/auth/forgot/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          confirm: {
            post: async function(data) {
              var url = rel(`/api/v1/auth/forgot/confirm/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        login: {
          post: async function(data) {
            var url = rel(`/api/v1/auth/login/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        logout: {
          post: async function() {
            var url = rel(`/api/v1/auth/logout/`);
            let res = await fetch(url, opt("POST"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          all: {
            post: async function() {
              var url = rel(`/api/v1/auth/logout/all/`);
              let res = await fetch(url, opt("POST"));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        password: {
          post: async function(data) {
            var url = rel(`/api/v1/auth/password/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        signup: {
          post: async function(data) {
            var url = rel(`/api/v1/auth/signup/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          confirm: {
            post: async function(data) {
              var url = rel(`/api/v1/auth/signup/confirm/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
          resend: {
            post: async function(data) {
              var url = rel(`/api/v1/auth/signup/resend/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
      },
      campaigns: {
        query: async function() {
          var url = rel(`/api/v1/campaigns/`);
          let res = await fetch(url, opt("GET"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        obtain: async function(args) {
          var url = rel(`/api/v1/campaigns/${args.campaign}/`);
          let res = await fetch(url, opt("GET"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        activities: {
          query: async function(args) {
            var url = rel(`/api/v1/campaigns/${args.campaign}/activities/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          obtain: async function(args) {
            var url = rel(`/api/v1/campaigns/${args.campaign}/activities/${args.activity}/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          submit: {
            post: async function(args, data) {
              var url = rel(`/api/v1/campaigns/${args.campaign}/activities/${args.activity}/submit/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        claim: {
          post: async function(args, data) {
            var url = rel(`/api/v1/campaigns/${args.campaign}/claim/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        opt_in: {
          post: async function(args, data) {
            var url = rel(`/api/v1/campaigns/${args.campaign}/opt-in/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        opt_out: {
          post: async function(args) {
            var url = rel(`/api/v1/campaigns/${args.campaign}/opt-out/`);
            let res = await fetch(url, opt("POST"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
      },
      check: {
        query: async function() {
          var url = rel(`/api/v1/check/`);
          let res = await fetch(url, opt("GET"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
      },
      content: {
        blog: {
          query: async function() {
            var url = rel(`/api/v1/content/blog/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          obtain: async function(args) {
            var url = rel(`/api/v1/content/blog/${args.slug}/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        case_studies: {
          query: async function() {
            var url = rel(`/api/v1/content/case-studies/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          obtain: async function(args) {
            var url = rel(`/api/v1/content/case-studies/${args.slug}/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
      },
      nlp: {
        check: {
          post: async function(data) {
            var url = rel(`/api/v1/nlp/check/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
      },
      products: {
        dismiss: {
          post: async function(args) {
            var url = rel(`/api/v1/products/${args.product_id}/dismiss/`);
            let res = await fetch(url, opt("POST"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        feed: {
          query: async function() {
            var url = rel(`/api/v1/products/feed/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          available: {
            query: async function() {
              var url = rel(`/api/v1/products/feed/available/`);
              let res = await fetch(url, opt("GET"));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        review: {
          post: async function(args) {
            var url = rel(`/api/v1/products/${args.product_id}/review/`);
            let res = await fetch(url, opt("POST"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
        },
        reviews_on_demand: {
          submit: {
            post: async function(args, data) {
              var url = rel(`/api/v1/products/reviews-on-demand/${args.rod_product_id}/submit/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
      },
      profile: {
        query: async function() {
          var url = rel(`/api/v1/profile/`);
          let res = await fetch(url, opt("GET"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        update: async function(data) {
          var url = rel(`/api/v1/profile/`);
          let res = await fetch(url, opt("PATCH", data));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        address: {
          query: async function() {
            var url = rel(`/api/v1/profile/address/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          update: async function(data) {
            var url = rel(`/api/v1/profile/address/`);
            let res = await fetch(url, opt("PUT", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          verify: {
            post: async function(data) {
              var url = rel(`/api/v1/profile/address/verify/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        countries: {
          query: async function() {
            var url = rel(`/api/v1/profile/countries/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          obtain: async function(args) {
            var url = rel(`/api/v1/profile/countries/${args.country}/`);
            let res = await fetch(url, opt("GET"));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          postcode: {
            query: async function(args, query) {
              var url = rel(`/api/v1/profile/countries/${args.country}/postcode/`);
              if (query) {
                url = `${url}?${qs(query)}`;
              }
              let res = await fetch(url, opt("GET"));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        email: {
          post: async function(data) {
            var url = rel(`/api/v1/profile/email/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          confirm: {
            post: async function(data) {
              var url = rel(`/api/v1/profile/email/confirm/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
        phone: {
          post: async function(data) {
            var url = rel(`/api/v1/profile/phone/`);
            let res = await fetch(url, opt("POST", data));
            let body = null;
            try {
              body = (await res.json());
            } catch (err) {
              body = null;
            }
            res = {
              status: res.status,
              body,
            };
            if (pipe) {
              res = pipe(res);
            }
            return res;
          },
          confirm: {
            post: async function(data) {
              var url = rel(`/api/v1/profile/phone/confirm/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
      },
      socials: {
        query: async function() {
          var url = rel(`/api/v1/socials/`);
          let res = await fetch(url, opt("GET"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        post: async function(args, data) {
          var url = rel(`/api/v1/socials/${args.provider}/`);
          let res = await fetch(url, opt("POST", data));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        remove: async function(args) {
          var url = rel(`/api/v1/socials/${args.provider}/`);
          let res = await fetch(url, opt("DELETE"));
          let body = null;
          try {
            body = (await res.json());
          } catch (err) {
            body = null;
          }
          res = {
            status: res.status,
            body,
          };
          if (pipe) {
            res = pipe(res);
          }
          return res;
        },
        tiktok: {
          mobile: {
            exchange_code: {
              post: async function(data) {
                var url = rel(`/api/v1/socials/tiktok/mobile/exchange-code/`);
                let res = await fetch(url, opt("POST", data));
                let body = null;
                try {
                  body = (await res.json());
                } catch (err) {
                  body = null;
                }
                res = {
                  status: res.status,
                  body,
                };
                if (pipe) {
                  res = pipe(res);
                }
                return res;
              },
            },
          },
          track: {
            query: async function() {
              var url = rel(`/api/v1/socials/tiktok/track/`);
              let res = await fetch(url, opt("GET"));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
            post: async function(data) {
              var url = rel(`/api/v1/socials/tiktok/track/`);
              let res = await fetch(url, opt("POST", data));
              let body = null;
              try {
                body = (await res.json());
              } catch (err) {
                body = null;
              }
              res = {
                status: res.status,
                body,
              };
              if (pipe) {
                res = pipe(res);
              }
              return res;
            },
          },
        },
      },
    },
  };
};
export default schema;
